export const ENDORSELY_ORGANIZATION_ID = "20496996-7ccc-4595-a152-7d04a82fbb83";
export const ENDORSELY_REFERRAL_STORAGE_KEY = "endorsely_referral";

const REFERRAL_ID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

declare global {
  interface Window {
    endorsely_referral?: string;
  }
}

export function isValidEndorselyReferral(value?: string | null) {
  return Boolean(value && REFERRAL_ID_PATTERN.test(value.trim()));
}

export function getStoredEndorselyReferral() {
  if (typeof window === "undefined") return null;

  const referralId =
    window.endorsely_referral ||
    window.localStorage.getItem(ENDORSELY_REFERRAL_STORAGE_KEY);

  return isValidEndorselyReferral(referralId) ? referralId!.trim() : null;
}

export function captureEndorselyReferral() {
  if (typeof window === "undefined") return null;

  const referralId = window.endorsely_referral;
  if (!isValidEndorselyReferral(referralId)) return null;

  window.localStorage.setItem(ENDORSELY_REFERRAL_STORAGE_KEY, referralId!.trim());
  return referralId!.trim();
}

export function initEndorselyReferralCapture() {
  if (typeof window === "undefined") return;

  captureEndorselyReferral();

  window.addEventListener("load", captureEndorselyReferral, { once: true });

  let attempts = 0;
  const interval = window.setInterval(() => {
    attempts += 1;
    if (captureEndorselyReferral() || attempts >= 20) {
      window.clearInterval(interval);
    }
  }, 250);
}
